import { useGetOrganizationProposalLayoutContentSettingsQuery } from "generated/graphql";
import { useMemo } from "react";

export default function useGetOrganizationProposalLayoutContentSettings() {
  const {
    data: graphqlData,
    loading,
    error,
  } = useGetOrganizationProposalLayoutContentSettingsQuery({
    fetchPolicy: "cache-first",
  });

  const data = useMemo(() => {
    return graphqlData?.getOrganizationProposalLayoutContentSettings ?? [];
  }, [graphqlData]);

  return { data, loading, error } as const;
}
